import script from "./ElementAddon.vue?vue&type=script&lang=js"
export * from "./ElementAddon.vue?vue&type=script&lang=js"

import "./ElementAddon.vue?vue&type=style&index=0&id=2bcd543c&lang=scss"

const __exports__ = script;

export default __exports__